import React from "react";
import { Link } from "react-router-dom";

const CartError = () => {
  return (
    <div
      className="success-page"
      style={{ textAlign: "center", padding: "50px" }}
    >
      <h1 style={{ color: "red" }}>❌ Došlo je do greške!</h1>
      <p>Nažalost, vaša porudžbina nije mogla da bude obrađena.</p>
      <p>Molimo vas da pokušate ponovo ili kontaktirate podršku.</p>
      <Link to="/" style={{ color: "#1976d2", textDecoration: "none" }}>
        Povratak na početnu stranicu
      </Link>
    </div>
  );
};

export default CartError;
